export const styles = {
  empty: {
    img: {
      mb: "1rem",
    },
    color: "events.lightBlack",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    pt: "1.25rem",
    fontWeight: 400,
  },
  loading: {
    position: "relative",
  },
};
